import React from 'react'

import { Box } from '@material-ui/core'

interface Children {
  children: React.ReactNode
}

function GridTemplate3xN({ children }: Children) {
  return (
    <Box
      p={6}
      flexBasis="inherit"
      display="grid"
      gridTemplateColumns="repeat(2, [col] 1fr) [col last-col] 1fr"
      gridAutoColumns="1fr"
      gridTemplateRows="auto"
      gridGap={24}
      height="max-content"
    >
      {children}
    </Box>
  )
}

export default GridTemplate3xN
